module.exports = __webpack_public_path__ + "img/rightvector.c426fb3a.svg";